import { routesNames } from '@/core/constants'
import SelecaoItensPedido from '@/views/pages/pedido/selecao-itens/SelecaoItensPedido.vue'
import AcessarPedidoView from '@/views/pages/pedido/acessar/AcessarPedidoView.vue'
import PedidoAbasInternas from '@/views/routers/routes/pedido/pedido-abas-internas'
import ProcessoDigitalPedido from '@/views/routers/routes/pedido/processo-digital/processo-digital-pedido'

export default [
	{
		name: routesNames.PEDIDO.NOVO_VIEW,
		path: '/pedido/selecao-de-itens/:id/:tipoAcesso',
		component: SelecaoItensPedido,
		meta: {
			page: {
				title: 'Seleção de Itens',
				subtitle: 'Pedido',
				showAutoSave: true,
			},
		},
	},
	...ProcessoDigitalPedido,
	{
		name: routesNames.PEDIDO.ACESSAR_VIEW,
		path: '/pedido/:id/:tipoAcesso/',
		component: AcessarPedidoView,
		meta: {
			page: {
				title: 'Pedido',
				subtitle: 'Acessar',
			},
			requiresAuth: true,
		},
		children: [...PedidoAbasInternas],
	},
]
